
import React from "react";
import { FormFieldType } from "@/types/form";
import { InstructionBox } from "../components";
import { useTranslation } from "react-i18next";
import { tField } from "../utils/i18nField";

interface InstructionProps {
  element: FormFieldType;
}

export const Instruction: React.FC<InstructionProps> = ({ element }) => {
  const { t } = useTranslation();
  return (
    <InstructionBox>
      <div className="whitespace-pre-line text-sm">{tField(t, element.text)}</div>
    </InstructionBox>
  );
};

export default Instruction;
